var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.displayAltCached},[(_vm.displayIco)?_c('img',{class:_vm.iconClass,attrs:{"src":_vm.displayIco,"alt":_vm.displayAltCached,"title":_vm.displayAltCached,"height":_vm.iconSize}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }